import Ac from "./images/ac-repair.svg";
import CarDetailing from "./images/car-detailing.svg";
import Steering from "./images/steering.svg";
import Suspension from "./images/suspension.svg";

export const CAR_HEALTH_DETAILS = {
    ENGINE_TRANSMISSION: "Engine & Transmission",
    AIR_CONDITIONING: "Air Conditioning",
    STEERING: "Steering, Suspension & Brakes",
    EXTERIOR: "Exterior & Tyres"
};

export const CAR_HEALTH_REPORT_STATUS = {
    INITIATED: "INITIATED",
    FULFILLMENT_PENDING: "FULFILLMENT_PENDING",
    FULFILLED: "FULFILLED",
    FULFILLMENT_UNSUCCESSFULL: "FULFILLMENT_UNSUCCESSFULL",
    REFUND_PENDING: "REFUND_PENDING",
    REFUNDED: "REFUNDED",
    REFUND_FAILED: "REFUND_FAILED"
};

export const CAR_HEALTH_INFO = {
    [CAR_HEALTH_DETAILS.ENGINE_TRANSMISSION]: {
        label: "Engine & Transmission",
        icon: Suspension,
        rating: "0.0"
    },
    [CAR_HEALTH_DETAILS.AIR_CONDITIONING]: {
        label: "Air Conditioning",
        icon: Ac,
        rating: "0.0"
    },
    [CAR_HEALTH_DETAILS.STEERING]: {
        label: "Steering, Suspension & Brakes",
        icon: Steering,
        rating: "0.0"
    },
    [CAR_HEALTH_DETAILS.EXTERIOR]: {
        label: "Exterior & tyres",
        icon: CarDetailing,
        rating: "0.0"
    }
};

export const REPORT_STATUS = {
    PENDING: "PENDING",
    BOUGHT: "BOUGHT",
    NOT_BOUGHT: "NOT_BOUGHT",
    NOT_FOUND: "NOT_FOUND"
};

export const HEADING_REPORT_DETAILS = {
    [REPORT_STATUS.PENDING]: {
        heading: "Your Car Inspection Report is being generated!",
        subHeading: "Please wait while we assist you"
    },
    [REPORT_STATUS.BOUGHT]: {
        heading: "Your Car Inspection Report is ready!",
        subHeading: "Download your detailed Car Inspection Report now."
    },
    [REPORT_STATUS.NOT_BOUGHT]: {
        heading: "Car Inspection Report ",
        subHeading: "& get information on 300+ inspected parameters"
    },
    [REPORT_STATUS.NOT_FOUND]: {
        heading: "Car Inspection Report ",
        subHeading: ""
    }
};

export const DEFAULT_BACKGROUND_START_COLOR = "#EDE9D9";
export const DEFAULT_BACKGROUND_END_COLOR = "#ffffff";
export const DEFAULT_BORDER_START_GRADIENT = "#BCAB70";
export const DEFAULT_BORDER_END_GRADIENT = "#BCAB7000";
export const BACKGROUND_DIRECTION = "to bottom";
export const BORDER_DIRECTION = "to bottom";

export const PACKAGE_BACKGROUND_START_COLOR = "#AA811933";
export const PACKAGE_BACKGROUND_END_COLOR = "#AA811900";
export const PACKAGE_BACKGROUND_DIRECTION = "to bottom";
